import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Toaster } from 'react-hot-toast';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import jwt_decode from 'jwt-decode';
import { isJwtExpired } from 'jwt-check-expiration';

import Services from '../services/services';
import resetPasswordStyles from '../styles/resetPasswordStyles';
import EmailVerified from '../ui/signupSkeleton/EmailVerified';

import {
  showLoadToaster,
  showSuccToaster,
  showErrToaster,
} from '../utils/toasterFunctions';

const useStyles = makeStyles((theme) => resetPasswordStyles(theme));

function EmailVerifySuccess() {
  let { token } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const [userId, setUserId] = useState(0);
  const [isVerified, setIsVerfied] = useState(false);
  const [isLinkExpired, setIsLinkExpired] = useState(false);

  const handleOk = () => {
    history.push('/');
  };

  const handleClose = () => {};

  const updateEmailStatus = async () => {
    try {
      const res = await Services.emailVerify(userId);
      if (res.data.responseCode === 200) {
        setIsVerfied(true);
        showSuccToaster(res.data.details);
        return;
      }
      showErrToaster(res.data.details);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userId) {
      updateEmailStatus();
      // console.log(userId, 'userid');
    }
  }, [userId]);

  useEffect(() => {
    try {
      const isExpired = isJwtExpired(token);
      // setIsLinkExpired
      if (isExpired) {
        setIsLinkExpired(isExpired);
        // setDialogOpen(true);
        return;
      } else {
        const decoded = jwt_decode(token);
        // const tokens = {
        //   accessToken: token,
        //   refreshToken: token,
        // };
        // setUserBrowserStorage('togetherTokens', JSON.stringify(tokens));
        setUserId(decoded.user_id);
      }
    } catch (error) {
      //invalid token specified //error.message
      showErrToaster(error.message);
    }

    // try {
    //   const decoded = jwt_decode(token);
    //   setUserId(decoded.user_id);
    // } catch (error) {
    //   //invalid token specified //error.message
    //   showErrToaster(error.message);
    // }
  }, []);

  return (
    <Grid className={classes.gridOccupy}>
      <EmailVerified
        isExpired={isLinkExpired}
        isVerified={isVerified}
        popOverContainer={classes.popOverContainer}
        btnStyleJoin={classes.btnStyleJoin}
        arrowIcon={classes.arrowIcon}
        handleOk={handleOk}
        handleClose={handleClose}
      />
      <Toaster position="top-center"></Toaster>
    </Grid>
  );
}

export default EmailVerifySuccess;
